import { Button } from 'components/Button'
import { useRootStore } from 'hooks/rootStore'
import { useTranslationTyped } from 'i18n/i18n'

export const NotFoundPage = function NotFoundPage() {
  const rootStore = useRootStore()
  const { tt } = useTranslationTyped()
  return (
    <div className="box-border flex h-full w-full grow flex-col items-center justify-center rounded-3xl bg-core-tertiary p-8 px-10 align-middle text-core-on-tertiary">
      <div className="mb-5">{tt.pages.application.not_found.title()}</div>
      <div>
        <Button
          onClick={() => rootStore.navigateTo('home')}
          className="bg-core-primary text-core-on-primary"
        >
          {tt.pages.application.not_found.back_to_home()}
        </Button>
      </div>
    </div>
  )
}
